
function fetchAndUpdateProducts(event, sectionId, sectionBlockId, sectionType, searchType = '', callback = () => { }) {
    const urlparams = new URLSearchParams(window.location.search);
    const q = urlparams.get('q') ? urlparams.get('q') : '';

    if (sectionType == 'search' && q == '') return;

    const mainSearchAjaxId = `#bb-main-search-ajax #search-content`;
    const mainContentId = `#main-${sectionType}-${sectionId}`;
    const productContentId = `#product-content-${sectionId}`;
    const articleContentId = `#article-content-${sectionId}`;
    const pageContentId = `#page-content-${sectionId}`;
    const mainPaginationId = `#pagination-${sectionId}-${sectionType}`;
    const gridId = `#main-container-${sectionId}`;
    const mainFilterLabelId = `#filter-label-${sectionBlockId}`;
    const $formId = `form.filter-form-${sectionBlockId}`;
    const $availabilityId = `input[name="filter.v.availability"]:checked`;

    // getElements
    var mainFilterLabel = document.querySelectorAll(mainFilterLabelId);
    const $curGrid = document.querySelector(gridId);
    const $form = document.querySelector($formId);
    const $availabilityChecked = document.querySelector($availabilityId);

    if (!$curGrid) return;

    // prepare data for submit
    let formData = new FormData();
    if (urlparams.has('sort_by')) formData.set('sort_by', urlparams.get('sort_by'));

    if (searchType == 'product' || sectionType == 'collection') {
        if ($form) {
            formData = new FormData($form);
            if (urlparams.has('sort_by')) formData.set('sort_by', urlparams.get('sort_by'));
        }
        const currentInput = event?.target || document;
        const paramName = currentInput?.name;

        if (currentInput.tagName == 'BB-CUSTOM-SELECT') {
            formData.set(event.detail.name, event.detail.value);
            // Trang search: ghi sort_by vào URL để phân trang AJAX / tải lại giữ đúng thứ tự
            if (sectionType == 'search') {
                const pageUrl = new URL(window.location.href);
                pageUrl.searchParams.set(event.detail.name, event.detail.value);
                pageUrl.searchParams.delete('page');
                window.history.replaceState({}, '', pageUrl);
            }
        } else if (paramName && !formData.has(paramName)) {
            const checkedInputs = document.querySelectorAll(`input[name="${paramName}"]:checked`);
            Array.from(checkedInputs).forEach(el => formData.append(paramName, el.value));
        }

        let filterAvailability = $availabilityChecked ? $availabilityChecked.value : '';
        if (filterAvailability != '') {
            formData.set('filter.v.availability', filterAvailability);
        }

    }

    formData.append('q', q);

    if (sectionType == 'search') {
        var page = 1;

        const link = event.target?.closest('.search-pagination-link');
        if (link && link.href) {
            const linkUrl = new URL(link.href);
            page = linkUrl.searchParams.get('page');
        }

        formData.append('type', searchType);
        formData.append('view', 'ajax');
        formData.append('page', page);
    }

    const params = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${params}`;

    $curGrid.setAttribute('aria-busy', 'true');
    $curGrid.classList.add('gwc-grid-loading');

    fetch(url)
        .then(response => {
            if (!response.ok) throw new Error('Unable to load products');
            return response.text();
        })
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const noResultsMessage = document.createElement('div');
            noResultsMessage.className = 'bb-no-results-message';
            noResultsMessage.innerHTML = '<p>No products found matching filter.</p>';

            if (sectionType == 'search') {
                if (searchType == 'product')
                    this.appendHtmlToElement(doc, `${mainContentId} ${productContentId}`, mainSearchAjaxId, noResultsMessage);
                else if (searchType == 'article')
                    this.appendHtmlToElement(doc, `${mainContentId} ${articleContentId}`, mainSearchAjaxId, noResultsMessage);
                else if (searchType == 'page')
                    this.appendHtmlToElement(doc, `${mainContentId} ${pageContentId}`, mainSearchAjaxId, noResultsMessage);

                callback(doc);
            }

            if (sectionType == 'collection') {
                this.appendHtmlToElement(doc, mainContentId, mainContentId, noResultsMessage);
            }

            mainFilterLabel
            var newMainFilterLabel = doc.querySelectorAll(mainFilterLabelId);

            if (newMainFilterLabel) {
                mainFilterLabel.forEach(function (el, index) {
                    if (newMainFilterLabel[index] != undefined) {
                        let newSpan = newMainFilterLabel[index].querySelector('span');
                        if (newSpan) {
                            el.querySelector('span').innerHTML = newSpan.innerHTML;
                        } else {
                            el.querySelector('span').innerHTML = '';
                        }
                    }
                });
            }

            if (window.AOS) {
                setTimeout(function () {
                    if (typeof AOS.init === 'function') {
                        AOS.init();
                    } else if (typeof AOS.refresh === 'function') {
                        AOS.refresh();
                    }
                }, 50);
            }

            if (typeof initShopUIHandlers === 'function') {
                initShopUIHandlers();
            }

            const renderedCards = $curGrid.querySelectorAll('.bb-pro-box');
            renderedCards.forEach(card => card.classList.add('gwc-fade-in'));
            $curGrid.classList.remove('gwc-grid-loading');
            $curGrid.removeAttribute('aria-busy');
            window.setTimeout(() => {
                renderedCards.forEach(card => card.classList.add('is-visible'));
            }, 20);

            if (sectionType == 'collection') {
                window.history.replaceState({}, '', url);
            }
        })
        .catch(() => {
            $curGrid.classList.remove('gwc-grid-loading');
            $curGrid.removeAttribute('aria-busy');
            window.location.assign(url);
        });
}

function appendHtmlToElement(doc, curContentId, newContentId, noResultsMessage) {
    // Bind search product content
    var curContent = document.querySelector(curContentId);
    var newContent = doc.querySelector(newContentId);
    if (newContent) {
        curContent.innerHTML = newContent.innerHTML;
    } else {
        curContent.innerHTML = '';
        curContent.appendChild(noResultsMessage);
    }

    // Check and update pagination
    var hasPagination = doc.querySelector(`${newContentId} .bb-pro-pagination`);
    var parentElement = curContent.closest('.search-page-section');
    if (parentElement) {
        var resultsCount = newContent.dataset.resultsCount;
        if (hasPagination || resultsCount > 0) {
            parentElement.style.display = 'block';
        } else {
            parentElement.style.display = 'none';
        }
    }
}

function handleFilterInputChange(event) {
    event.preventDefault();

    const sectionId = event.target.dataset.sectionId;
    const blockId = event.target.dataset.blockId;
    const sectionBlockId = `${sectionId}-${blockId}`;
    const sectionType = event.target.dataset.sectionType; // collection or search

    if (typeof fetchAndUpdateProducts == 'function') {
        return fetchAndUpdateProducts(event, sectionId, sectionBlockId, sectionType, sectionType == 'search' ? 'product' : '');
    }
    return;
}

document.querySelectorAll('.bb-filter-input, bb-custom-select.sort-by').forEach(function (input) {
    input.addEventListener('change', event => handleFilterInputChange(event));
});
